import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[iframeControl]'
})
export class IframeControlDirective {

  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) { 
    
  }

  @HostListener('mouseenter') onMouseEnter(event: Event){
    const hoverSection = this.element.nativeElement.querySelector('.hoverSection');
    this.renderer.setStyle(hoverSection,'display','block');
  }
  @HostListener('mouseleave') onMouseLeave(event: Event){
    const hoverSection = this.element.nativeElement.querySelector('.hoverSection');
    this.renderer.setStyle(hoverSection,'display','none');
  }

}
